import clsx from "clsx";
import { FunctionComponent } from "react";

import { useIsEntitled } from "@voxmedia/duet-context/context/auth-context";
import type {
  AdTypes,
  SlotViewport,
} from "@voxmedia/duet-context/context/config-context";
import {
  useConfigContext,
  AdConfig,
  NetworkConfig,
} from "@voxmedia/duet-context/context/config-context";

import * as styles from "./Ad.css";

const viewportDisplayClasses: Record<SlotViewport, string> = {
  all: styles.showAll,
  mobile: styles.showMobile,
  tablet: styles.showTablet,
  mobileAndTablet: styles.showMobileAndTablet,
  desktop: styles.showDesktop,
  tabletAndDesktop: styles.showTabletAndDesktop,
  flexTabletAndDesktop: styles.flexTabletAndDesktop,
};
interface Props {
  adType: AdTypes;
}

const Ad: FunctionComponent<Props> = ({ adType }) => {
  const {
    adConfig: { staticAdConfig },
    networkConfig,
  }: { adConfig: AdConfig; networkConfig: NetworkConfig } = useConfigContext();
  const concertAdsNetwork = networkConfig.concertAds.network;
  const hasSubscription = useIsEntitled();

  return (
    <>
      {staticAdConfig[adType]?.map(
        (
          {
            containerClassName,
            slotClassName,
            style,
            slotName,
            viewport,
            hideSlot,
            hideIfSubscription,
          },
          idx,
        ) => {
          const shouldHideForSubscriber =
            hasSubscription && hideIfSubscription?.includes(concertAdsNetwork);
          const shouldHideForNetwork =
            Array.isArray(hideSlot) && hideSlot.includes(concertAdsNetwork);

          if (shouldHideForSubscriber || shouldHideForNetwork) {
            return;
          }

          return (
            <div
              key={idx}
              className={clsx(
                containerClassName,
                styles.adLayout,
                viewportDisplayClasses[viewport],
              )}
            >
              <div
                key={slotName}
                style={style}
                className={clsx(
                  styles.adLayout,
                  slotClassName,
                  adType === "networkRiverHome" && styles.networkRiverHome,
                )}
                data-concert={slotName}
              />
            </div>
          );
        },
      )}
    </>
  );
};

export default Ad;
